module.exports = __webpack_public_path__ + "static-portal/img/EAM.fcbb194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EAM.jpg
// module id = xhMl
// module chunks = 4